import {
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/components/ui/form';
import { addDays, format, parseISO } from 'date-fns';

import { DatePicker } from '@/components/ui/date-picker';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

interface DateFieldProps {
	name: string;
	label?: string;
	description?: string;
	displayFormat?: string;
	className?: string;
}

export function GroupPricingDateField({
	name,
	label,
	description,
	displayFormat = 'MM/dd/yyyy',
	className,
}: DateFieldProps) {
	const form = useFormContext();

	const { setValue, getValues } = form;

	const handleDateChange = (field: string, date: Date) => {
		if (field === 'check_in') {
			// check if check_out is before check_in set check_out to check_in + 1 day
			setValue('check_in', format(date, 'yyyy-MM-dd'));
			if (date >= parseISO(getValues('check_out'))) {
				setValue('check_out', format(addDays(date, 1), 'yyyy-MM-dd'));
			}
		} else if (field === 'check_out') {
			// check if check_in is after check_out set check_in to check_out - 1 day
			setValue('check_out', format(date, 'yyyy-MM-dd'));
			if (date <= parseISO(getValues('check_in'))) {
				setValue('check_in', format(addDays(date, -1), 'yyyy-MM-dd'));
			}
		}
	};

	return (
		<div className='tw-space-y-2'>
			<FormField
				control={form.control}
				name={name}
				render={({ field }) => (
					<FormItem className='flex flex-col'>
						<FormLabel>{label ?? _.startCase(name)}</FormLabel>
						<DatePicker
							date={
								typeof field.value === 'string'
									? parseISO(field.value)
									: field.value
							}
							onSelect={(date) => {
								// Store dates in ISO format for consistency with API
								date && handleDateChange(name, date);
							}}
							className={className ?? 'tw-w-full'}
							displayFormat={displayFormat}
						/>
						<FormDescription>{description}</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
}
